import { ANCHOR_TYPE } from '../constants'
import { selectedInstanceIds, selectableVisitCycles } from '../hooks/anchorConstraints'

export const listForAnchorType = (type, entityOptions = {}) => {
  if (type === ANCHOR_TYPE.arm) return entityOptions.arms
  if (type === ANCHOR_TYPE.phase) return entityOptions.phases
  if (type === ANCHOR_TYPE.visitCycle) return selectableVisitCycles(entityOptions)
  if (type === ANCHOR_TYPE.visit) return entityOptions.visits
  if (type === ANCHOR_TYPE.track) return entityOptions.tracks
  if (type === ANCHOR_TYPE.chapter) return entityOptions.chapters
  if (type === ANCHOR_TYPE.instrument) return entityOptions.instruments
  return []
}

export const formatVisitName = (visit, entityOptions = {}) => {
  if (!visit) return ''
  const arm = (entityOptions.arms || []).find(item => String(item.id) === String(visit.armId))
  if (arm?.name && !String(visit.name || '').includes(arm.name)) {
    return `${visit.name} — ${arm.name}`
  }
  return visit.name || String(visit.id || '')
}

export const namesForAnchor = (anchor, entityOptions = {}) => {
  const list = listForAnchorType(anchor?.type, entityOptions) || []
  const items = selectedInstanceIds(anchor)
    .map(id => list.find(entry => String(entry.id) === String(id)))
    .filter(Boolean)
  const multiArm =
    anchor?.type === ANCHOR_TYPE.visit && new Set(items.map(item => item.armId).filter(Boolean)).size > 1
  return items
    .map(item => (anchor.type === ANCHOR_TYPE.visit && multiArm ? formatVisitName(item, entityOptions) : item.name))
    .filter(Boolean)
    .join(', ')
}

export const visitOptions = entityOptions =>
  (entityOptions?.visits || []).map(visit => ({
    key: visit.id,
    text: formatVisitName(visit, entityOptions),
  }))

/** Instrument anchor dropdown — title with faded id in parentheses. */
export const instrumentOptions = entityOptions =>
  (entityOptions?.instruments || []).map(item => ({
    key: item.id,
    text: `${item.name}(${item.id})`,
    name: item.name,
    idLabel: item.id,
  }))
